import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataSourceItem, TableColumnsProp } from '../../models/tables.model';
import { CommonTableService } from '../../services/common-table.service';
import {
  dateTimeFormat,
  ModalPopupMessages,
  popupButtons,
} from '../../utility/constants';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material.module';
import { CommonService } from '../../services/common.service';
import {
  isPrintPayloadMessage,
  startPrintPreviewReadyNotifier,
} from '../../utility/print-layout.util';

@Component({
  selector: 'app-summary-page-print',
  templateUrl: './summary-page-print.component.html',
  styleUrl: './summary-page-print.component.scss',
  standalone: true,
  imports: [CommonModule, MaterialModule],
})
export class SummaryPagePrintComponent implements OnInit, OnDestroy {
  private printPayloadReceived = false;
  private stopReadyNotifier?: () => void;
  public dataSource: DataSourceItem[] = [];
  public displayedColumns!: string[];
  public summaryCustomiseTableColumns!: TableColumnsProp[];
  public isFrom!: string;
  public dateFormat = dateTimeFormat.onlyDate;
  public pageSize = '';
  public popupButtons = popupButtons;
  public isForprint = false;
  public isPrintClicked = false;
  public isPrintWarning = false;
  public warningMessage = ModalPopupMessages.printWarningContent;
  /** PAC-24667: Shipment column where a master row lists its linked shipments. */
  public readonly linkedShipmentColumnKey = 'hawbExt';

  constructor(
    public commonTableService: CommonTableService,
    public commonService: CommonService
  ) {
    window.addEventListener('message', this.messageHandler);
  }

  ngOnInit(): void {
    this.stopReadyNotifier = startPrintPreviewReadyNotifier(
      () => this.printPayloadReceived
    );
  }

  ngOnDestroy() {
    this.stopReadyNotifier?.();
    window.removeEventListener('message', this.messageHandler);
  }

  messageHandler = (event: any) => {
    // Only the summary print payload from the opener; ignore any other message.
    if (isPrintPayloadMessage(event, ['selectedData', 'customizeColumns'])) {
      this.printPayloadReceived = true;
      this.stopReadyNotifier?.();
      this.pageSize = event.data.selectedPageSize;
      this.displayedColumns = event.data.displayColumns;
      this.summaryCustomiseTableColumns = event.data.customizeColumns;
      this.dataSource = event.data.selectedData;
      this.isForprint = event.data.isPrintDialogRequired;
      this.isPrintWarning = event.data.isPreviewWarning;
      if (this.isForprint) {
        this.print();
      }
    }
  };
  get showSetRangeSubheader(): boolean {
     return this.summaryCustomiseTableColumns?.some(col => col.key === 'setRange');
  }
  get showApChargeSubheader() : boolean{
      return this.summaryCustomiseTableColumns?.some(col => col.key === 'apChargeCodeDetails');  
  }

  get showSetCurrecnySubheader(): boolean {
    return this.summaryCustomiseTableColumns?.some(col => col.key === 'viewDetails');
  }
  public print() {
    this.isPrintClicked = true;
    window.onafterprint = () => {
      window.close();
    };
    setTimeout(() => {
      window.print();
    }, 0);
  }
}
